import { PageData } from '@/types/contentServerContract';
import httpService from '@/core/http/http.service';
import serverContext from '@/core/serverContext.service';

class ContentApiService {
    // Can throw a HttpCancelError Error if a new call is initiated while not done
    async getPage(relativeUrl: string): Promise<PageData> {
        return httpService.getPage(this.ensureCulture(relativeUrl));
    }

    // Can NOT throw a HttpCancelError Error if a new call is initiated while not done
    async getPageParallel<T>(relativeUrl: string): Promise<PageData> {
        return httpService.getPageParallel(this.ensureCulture(relativeUrl));
    }

    // Can NOT throw a HttpCancelError Error if a new call is initiated while not done
    async getContent<T>(relativeUrl: string): Promise<T> {
        const result = await httpService.getPageParallel(this.ensureCulture(relativeUrl));
        return result.jsonContent.content as T;
    }

    ensureCulture(relativeUrl: string): string {
        if (serverContext.isPreview) {
            return `${serverContext.contentHost}${relativeUrl}&getcontent=true`;
        } else if (relativeUrl.includes(serverContext.siteInfo.url!)) {
            return `${serverContext.contentHost}${relativeUrl}`;
        } else {
            return `${serverContext.contentHost}${serverContext.siteInfo.url}${relativeUrl}`;
        }
    }
}

export default new ContentApiService();
